import React from 'react';
import PropTypes from 'prop-types';
import css from './Survey.css'
import SurveyStudentSearch from "./SurveyStudentSearch";
import SurveySearchIcon from "./SurveySearchIcon";
import SurveyInformation from "./SurveyInformation";

export default class TableHeader extends React.Component {

  onCloseSearch = () => {
    this.props.hideSearchBox();
    this.props.onSearchChange(""); // Erase search text
  }

  get surveySearch() {
    return this.props.displaySearchBox 
      ? <SurveyStudentSearch onCloseSearch={this.onCloseSearch} searchStudentInSurvey={this.props.onSearchChange} />
      : null;
  }

  get surveyInformation() {
    return this.props.displayInfoButton
      ? <SurveyInformation onClick={this.props.onClickInformationButton} />
      : null;
  }

  render() {
    return (
      <>
        {this.surveySearch}
        <div className={css['table-header']}>
          <SurveySearchIcon onSearchIconClickHandler={this.props.showSearchBox} />
          {this.surveyInformation}
        </div>
      </>
    );
  }
}

TableHeader.propTypes = {
  displaySearchBox: PropTypes.bool.isRequired,
  showSearchBox: PropTypes.func.isRequired,
  hideSearchBox: PropTypes.func.isRequired,
  displayInfoButton: PropTypes.bool.isRequired,
  onSearchChange: PropTypes.func.isRequired,
  onClickInformationButton: PropTypes.func.isRequired,
};
